import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

/**
 * Customer.io, or a stub that does nothing.
 *
 * `AnalyticsBrowser.load` does not check its own write key. Handed
 * `undefined` — which is every local dev machine and any CI build that does
 * not set `REACT_APP_CUSTOMERIO_WRITE_KEY` — it goes and requests
 * `https://cdp-eu.customer.io/v1/projects/undefined/settings`, gets a 404, and
 * logs it. On EVERY page load. That is a console error on a working app, which
 * is the kind of noise that trains people to ignore the console and miss the
 * next real one.
 *
 * `track.js` already wraps each call in try/catch, so a stub is enough and no
 * call site changes. The methods used there are `track`, `identify`, `alias`
 * and `reset`; the whole surface is stubbed regardless, because the next
 * caller should not have to discover which four were guessed at today.
 *
 * The key is a WRITE key, public by design and inlined into the bundle like
 * every `REACT_APP_*` var, so gating on its presence leaks nothing.
 */
const NOOP_METHODS = [
  "track",
  "identify",
  "alias",
  "reset",
  "page",
  "group",
  "screen",
];

function noopAnalytics() {
  return NOOP_METHODS.reduce((stub, method) => {
    stub[method] = () => Promise.resolve();
    return stub;
  }, {});
}

const writeKey = process.env.REACT_APP_CUSTOMERIO_WRITE_KEY;

export const cioanalytics = writeKey
  ? AnalyticsBrowser.load({ writeKey, cdnURL: "https://cdp-eu.customer.io" })
  : noopAnalytics();

export const customerIoEnabled = Boolean(writeKey);
